// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.5 5.5H12C13.1 5.5 14 6.4 14 7.5V12C14 13.1 13.1 14 12 14H7.5C6.4 14 5.5 13.1 5.5 12V7.5C5.5 6.4 6.4 5.5 7.5 5.5Z',
  'M4 10.5C2.9 10.5 2 9.6 2 8.5V4C2 2.9 2.9 2 4 2H8.5C9.6 2 10.5 2.9 10.5 4',
  'M7.65 9.8L9 11.15L11.9 8.25',
];
